var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 5a1 1 0 0 0-2 0v12.26c-.573-.514-1.219-1.202-1.838-1.915a51 51 0 0 1-1.658-2.023 99 99 0 0 1-.764-.994 1 1 0 0 0-1.546 1.265c.127.167.51.674.733.96.445.57 1.06 1.335 1.725 2.102.662.763 1.396 1.551 2.081 2.156.342.302.694.58 1.038.788.317.19.753.401 1.23.401l.176-.01c.406-.043.774-.224 1.05-.391a7.4 7.4 0 0 0 1.04-.788c.685-.605 1.419-1.393 2.08-2.156a53 53 0 0 0 2.459-3.062 1 1 0 0 0-1.546-1.265l-.251.327a56 56 0 0 1-2.171 2.69c-.62.713-1.264 1.401-1.838 1.916z"
  })));
};
export default SvgArrowDown;